import 'react';
import { Icon } from '@bucketplace/design-system/bds';
import { decorateComponent } from '../../documentComponents/decorateComponent.js';
import { getDisallowedAncestors } from '../../utils/ancestors.js';
import { jsx } from '@emotion/react';
import 'qs';
import 'query-string';
import { ProductListInspector } from './Inspector/index.js';
import { ProductList as ProductList$1 } from './ProductList.js';

var ProductList = decorateComponent(ProductList$1, 'block', {
  id: 'productList',
  label: '상품리스트',
  defaultProps: {
    type: 1,
    badgeType: 'none',
    products: [],
    useBuyButton: false
  },
  allowedChildren: [],
  disallowedAncestors: getDisallowedAncestors(['grid']),
  renderIcon: function renderIcon() {
    return jsx(Icon, {
      size: 18,
      name: "present_outline"
    });
  },
  renderInspector: ProductListInspector
});

export { ProductList as default };
//# sourceMappingURL=index.js.map
